package org.hs_soft.runmynesto.domain.model.home.template.tabs.tab_general.calendar

data class DayModel(
    val dayNumber:Int,
    val dayName:String,
    val isCurrentMonth:Boolean=false,
)
